import MediaInserterSelector from '@intercom/embercom-composer/components/media-inserter-video';
export default MediaInserterSelector;
